export default {
	firstName: 'user.firstName',
	lastName: 'user.lastName',
	name: 'artist.name',
	email: 'user.email',
	userName: 'user.userName',
	password: 'user.password',
	confirmPassword: 'user.confirmPassword',
	phoneNumber: 'user.phoneNumber',
	genre: 'artist.genre',
	// paymentServiceID: 'artist.paymentServiceID',
	dob: 'user.dob',
	hfmPicksOptIn: 'artist.hfmPicksOptIn',
	location: 'user.location',
	gender: 'user.gender'
};
